import { Component, OnInit, Input } from '@angular/core';
import { ConsultantResource, ProjectResource, ProjectService } from 'toolbandi-ui-lib';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CrudService, MessageService, Page, Search } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-project-consultants-add',
	templateUrl: './project-consultants-add.component.html',
	styleUrls: ['./project-consultants-add.component.scss']
})
export class ProjectConsultantsAddComponent implements OnInit {

	@Input()
	projectid: number;
	@Input()
	consultantid: number;

	associablerows: ConsultantResource[] = [];
	allassociablerows: ConsultantResource[] = [];

	associaterows: ProjectResource[] = [];
	allassociaterows: ProjectResource[] = [];

	associableloading = true;
	associateloading = true;

	advancedSearch = new Search('projectresource join consultantresource on projectresource.consresid = consultantresource.id');


	constructor(
		private projectService: ProjectService,
		private activeModal: NgbActiveModal,
		private crudService: CrudService<ProjectResource>,
		private messageService: MessageService,
		private translateService: TranslateService
	) { }

	ngOnInit() { }

	loadAssociableRes(): void {
		this.associableloading = true;
		this.projectService.getAssociableConsultantResources(this.projectid, +this.consultantid).subscribe((data: ConsultantResource[]) => {
			this.associablerows = data;
			this.allassociablerows = data;
			this.associableloading = false;
		});
	}

	loadAssociateRes(): void {
		this.associateloading = true;
		this.associaterows = [];

		if (this.projectid) {
			this.advancedSearch.addSimpleFilter('projectresource.projectid', this.projectid);
		}

		if (+this.consultantid) {
			this.advancedSearch.addSimpleFilter('consultantresource.consultantid', this.consultantid);
		}

		this.crudService.searchEntities(ProjectResource, 'projectresource', this.advancedSearch, new Page(1000)).subscribe((data: ProjectResource[]) => {
			this.associaterows = data;
			this.allassociaterows = data;
			this.associateloading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.associateloading = false;
		});
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	add(res: ConsultantResource): void {



		const projectresource = new ProjectResource();
		projectresource.projectid = this.projectid;
		projectresource.consresid = res.id;

		this.crudService.createEntity(ProjectResource, 'projectresource', projectresource).subscribe((res) => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.resource-add-success'),
				this.translateService.instant('labels.success')
			);
			this.loadAssociableRes();
			this.loadAssociateRes();
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	remove(projectresource: ProjectResource): void {


		this.crudService.deleteEntity(ProjectResource, 'projectresource', projectresource).subscribe((res) => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.resource-remove-success'),
				this.translateService.instant('labels.success')
			);
			this.loadAssociableRes();
			this.loadAssociateRes();
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	updateFilter(event): void {
		const val = event.target.value.toLowerCase();

		if (val) {
			this.associablerows = this.allassociablerows.filter(e => {
				return e.fullname?.toLowerCase().indexOf(val) >= 0;
			});
			this.associaterows = this.allassociaterows.filter(e => {
				return e.fullname?.toLowerCase().indexOf(val) >= 0;
			});

		} else {
			this.associablerows = this.allassociablerows.filter(tool => true);
			this.associaterows = this.allassociaterows.filter(tool => true);
		}
	}

	reload(): void {
		this.loadAssociableRes();
		this.loadAssociateRes();
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.loadAssociateRes();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.loadAssociateRes();
	}

}
